// Function to toggle modal
const toggleModal = (isOpen) => {
  const modal = document.getElementById('modal-car'); // Vyhledání modalu

  if (!modal) {
    console.error('Modal nebyl nalezen.');
    return;
  }

  if (isOpen) {
    document.body.classList.add('overflow-hidden', 'w-full', 'h-full'); // Přidání tříd na body
    modal.classList.remove('hidden'); // Zobrazení modalu
  } else {
    document.body.classList.remove('overflow-hidden', 'w-full', 'h-full'); // Odebrání tříd z body
    modal.classList.add('hidden'); // Skrytí modalu
  }
};

// Event listener pro otevření modalu
document.addEventListener('click', (event) => {
  if (event.target.matches('.modal-open-btn')) {
    toggleModal(true); // Otevření modalu
  }
});

// Event listener pro zavření modalu
document.addEventListener('click', (event) => {
  if (event.target.matches('#modal-close-btn')) {
    toggleModal(false); // Zavření modalu
  }
});